export default __webpack_public_path__ + "static/media/nftimg.3476fd05.jpg";